<template>
  <div>
    <div class="ts-grid ts-grid-cols-1 ts-gap-3">
      <div>
        <label class="ts-mb-0 ts-font-robot">{{ $t('task.estimated') }}</label>
        <div class="ts-flex ts-space-x-2">
          <a-range-picker
            v-model="model.estimate_date"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            class="ts-w-full"
          />
        </div>
        <div class="validate" v-if="errors.has('estimate_date')">
          {{ errors.first('estimate_date') }}
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot">{{ $t('task.actual') }}</label>
        <div class="ts-flex ts-space-x-2">
          <a-range-picker
            v-model="model.actual_date"
            format="DD-MM-YYYY"
            valueFormat="DD-MM-YYYY"
            class="ts-w-full"
          />
        </div>
        <div class="validate" v-if="errors.has('actual_date')">
          {{ errors.first('actual_date') }}
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot">{{ $t('task.site') }}</label>
        <div>
          <Select
            v-model="model.site_profile_id"
            :filterable="true"
            style="width:100%"
          >
            <Option v-for="item in siteList" :value="item.id" :key="item.id">{{
              item.site_name
            }}</Option>
          </Select>
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot">
          {{ $t('task.dependency') }}

          <small><i>click open then type any charactor to search</i></small>
        </label>
        <div class="ts-space-y-2">
          <Select
            filterable
            :remote-method="onSearchDependency"
            v-model="model.dependency_task_id"
            style="width:100%"
          >
            <Option v-for="item in tasks" :value="item.id" :key="item.id">{{
              item.title
            }}</Option>
          </Select>
        </div>

        <div class="validate" v-if="errors.has('dependency_task_id')">
          {{ errors.first('dependency_task_id') }}
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot">
          {{ $t('task.latLng') }}
        </label>
        <div class="ts-space-y-2">
          <div class="ts-grid ts-grid-cols-2 ts-gap-3">
            <input
              v-model="model.location_pin.lat"
              type="number"
              step="any"
              class="form-control"
              :placeholder="$t('task.latitude')"
            />
            <input
              v-model="model.location_pin.lng"
              type="number"
              step="any"
              class="form-control"
              :placeholder="$t('task.longitude')"
            />
          </div>
        </div>
      </div>
      <div>
        <label class="ts-mb-0 ts-font-robot">
          {{ $t('task.estimateQty') }}
        </label>
        <div class="ts-space-y-2">
          <div class="ts-grid ts-grid-cols-1 ts-gap-3">
            <input
              v-model="model.estimate_qty"
              type="number"
              step="any"
              class="form-control"
              :placeholder="$t('task.estimateQty')"
            />
          </div>
        </div>
      </div>
    </div>
    <iModalWrapper
      v-model="show_milestone_modal"
      v-if="show_milestone_modal"
      :title="$t('task.createMileStone')"
    >
      <CreateMileStone
        :projectId="model.project_id"
        @cancel="onMilestoneCancel"
        @milestone="onReceiveMilestone"
      />
    </iModalWrapper>
  </div>
</template>
<script>
import CreateMileStone from './create-milestone.vue'
import iModalWrapper from '../../components/i-modal-wrapper.vue'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import { debounce } from 'lodash'
export default {
  props: ['value', 'validate', 'resources'],
  components: {
    iModalWrapper,
    CreateMileStone
  },
  data() {
    return {
      tasks: [],
      show_project: false,
      show_milestone_modal: false,
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    siteList() {
      if (this.resources.sites) {
        return this.resources.sites
      }
      return []
    }
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', ['formViewModel']),
    showModalCreateMileStone() {
      if (this.model.project_id == '') {
        this.$toasted.error('Please choose any project first!')
        return
      }
      this.show_milestone_modal = true
    },
    onMilestoneCancel() {
      this.show_milestone_modal = false
    },
    onReceiveMilestone(milestone) {
      this.model.milestone_id = milestone.milestone_id
      this.$emit('add-milestone', {
        milestone_id: milestone.milestone_id,
        milestone_name: milestone.milestone_name,
        project_id: milestone.project_id
      })
    },
    onSearchDependency: debounce(function(query) {
      this.$emit('loading', true)
      this.formViewModel({
        fnName: 'task',
        search_task: query
      })
        .then(response => {
          this.tasks = response.data.task
        })
        .finally(() => this.$emit('loading', false))
    }, 500)
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
